import React, { useEffect, useState } from "react";
import Card from "components/Card";
import PagingTable from "components/Table/Paging";
import axios from "axios";
import { columns } from "./config";
import _ from "lodash";
import { staffClient } from "common/apis/staff";

const TreatmentPage = () => {
    const [refreshKey, setRefreshKey] = useState(_.uniqueId());

    const fetchData = async (page, limit) => {
        try {
            const params = {
                offset: (page - 1) * limit,
                limit: limit
            }
            // const ret = await axios.get(`https://rest.miview.shop/treatment`, { params });
            const ret = await staffClient.get("/treatment", { params });
            const { data, total } = ret.data;
            return {
                data,
                page,
                total
            }
        } catch (e) {
            console.log("[TreatmentPage] fetchData error", e);
            return {
                data: null,
                page,
                total: 0
            }
        }
    }

    const postData = async (row) => {
        try {
            // const ret = await axios.post(`https://rest.miview.shop/treatment`, row);
            const ret = await staffClient.post("/treatment", row);
            return ret.data;
        } catch (e) {
            console.log("[TreatmentPage] postData error", e);
            return null;
        }
    }

    const onCreate = async (row) => {
        console.log("[TreatmentPage] onCreate", row);
        const ret = await postData(row);
        if (ret) {
            setRefreshKey(_.uniqueId());
            return true;
        }
    }

    const onEdit = async (row) => {
        console.log("[onEdit] row", row);
        try {
            const body = {
                name: row.name,
                description: row.description,
            }
            // const ret = await axios.patch(`https://rest.miview.shop/treatment/${row.id}`, body);
            const ret = await staffClient.patch(`/treatment/${row.id}`, body);
            console.log("[onEdit] ret", ret);
            setRefreshKey(_.uniqueId());
            return ret.data;
        } catch (e) {
            console.log("[onEdit] error", e);
            return null;
        }
    }

    return (
        <Card>
            <div className="p-3">
                <PagingTable
                    fetchData={fetchData}
                    columns={columns}
                    refreshKey={refreshKey}
                    windowSize={100}
                    isCrudable={true}
                    onCreate={onCreate}
                    onEdit={onEdit}
                />
            </div>
        </Card>
    )
};

export default TreatmentPage;

